$(document).ready(function() {
  function frequentlyOrderedProductCarousel() {
    var $jcarousel = $('.ph-freqorderedproduct__jcarousel');

    $jcarousel
      .on('jcarousel:reload jcarousel:create', function() {
        var $carousel = $(this),
            width = $carousel.innerWidth();


        if (width >= 769) {
          width = width / 4;
        } else if (width >= 450) {
          width = width / 3;
        } else if (width <= 450) {
          width = width / 2;
        }

        $carousel.jcarousel('items').css('width', Math.ceil(width) + 'px');
      })
      .jcarousel({
        wrap: null

      }).jcarouselSwipe({
        perSwipe: 1
      });

    $('.ph-freqorderedproduct__prevarrow')
      .on('jcarouselcontrol:inactive', function() {
        $(this).addClass('inactive');
      })
      .on('jcarouselcontrol:active', function() {
        $(this).removeClass('inactive');
      })
      .jcarouselControl({
        target: '-=1'
      });

    $('.ph-freqorderedproduct__nextarrow')
      .on('jcarouselcontrol:inactive', function() {
        $(this).addClass('inactive');
      })
      .on('jcarouselcontrol:active', function() {
        $(this).removeClass('inactive');
      })
      .jcarouselControl({
        target: '+=1'
      });
  }

  function wowTextExtension() {
    var showChar = 30,
        ellipses = '...',
        showMoreText = $('.ph-collapsible').attr('data-seemore');

    $('.ph-collapsible').each(function() {
      var content = $(this).html(),
          contentSubstr = content.substr(0, showChar),
          contentMoreStr = content.substr(showChar, content.length - showChar),
          fullStr = '';

      if (content.length > showChar) {
        fullStr = contentSubstr + '<span class="moreelipses">' + ellipses + '</span><span class="ph-morecontent"><span>' + contentMoreStr +
        '</span>&nbsp;&nbsp;</span><span class="ph-morelink morelink">' + showMoreText + '</span>';
        $(this).html(fullStr);
      }
    });
  }

  frequentlyOrderedProductCarousel();

  if ($('.ph-collapsible').length > 0) {
    wowTextExtension();
  }

  if ($('.ph-freqorderedproduct__jcarousel-wrapper').length > 0) {
    var featureProdPriceHeight = 0,
        qutyProductHeight = 0;

    $('.ph-prodDetails').each(function() {
      featureProdPriceHeight = Math.max(featureProdPriceHeight, $(this).height());
    });
    $('.ph-prodDetails').css({
      height: featureProdPriceHeight + 'px'
    });
    $('.ph-productquantity').each(function() {
      qutyProductHeight = Math.max(qutyProductHeight, $(this).height());
    });
    $('.ph-productquantity').css('min-height', qutyProductHeight + 'px');
  }

  if ($('.template-pages-layout-landingLayout10Page').length > 0) {
    $('.action').remove();
    $('#header').remove();
  }

  function renderCss($element, styleProps) {
    $.each(styleProps, function(key, styleProp) {
      if (styleProp) {
        var cssProps = styleProp.split(':');

        if (cssProps[0] && cssProps[1]) {
          $element.css($.trim(cssProps[0]), $.trim(cssProps[1]));
        }
      }
    });
  }

  if ($('.datastyle').length > 0) {
    $('.datastyle').each(function() {
      var styleText = $(this).attr('data-style');

      if (styleText) {
        renderCss($(this), styleText.split(';'));
      }
    });
  }
});
